<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="预警时间:">
                <el-date-picker
                  style="width: 100%"
                  v-model="searchForm.createTime"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  type="date"
                  clearable
                  placeholder="请选择"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="所属机构:" prop="orderSource">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.orderSource"
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in companyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button
                  type="primary"
                  round
                  icon="el-icon-search"
                  @click="handleCheck()"
                ></el-button>
                <el-button
                  type="default"
                  round
                  icon="el-icon-refresh"
                  @click="handleReset()"
                ></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>

      <div class="warning-box">
        <div class="custom-tip">
          <el-image
            :src="require('@/assets/imgs/price-tip.png')"
            class="tip-img"
          ></el-image>
          <div class="tip-box">
            <div class="tip-title">
              <span>司机流失预警判定规则说明</span>
            </div>
            <div class="tip-list">
              平台每天00:00对司机的考勤信息及日均营收信息进行计算，并根据下述命中条件结合计算结果发出预警，请车队长每日00:30后及时关注司机流失预警信息。
            </div>
            <div class="tip-list">
              （1）连续三天未出勤：司机连续三天的排班计划为“不出勤”或排班计划为“出勤”但司机上报的信息为休息中或未上报时，则触发预警规则；
            </div>
            <div class="tip-list">
              （2）连续7天日均营收＜850元，平台将计算司机从入驻起每日的日均营收，若连续7天日均营收均＜850元时，则触发预警规则；
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange"
      >
        <!--        <template v-slot:status="{ row }">-->
        <!--          &lt;!&ndash;          <span class="common-status status-cancel">已取消</span>&ndash;&gt;-->
        <!--          <span class="common-status status-confirm">已完成</span>-->
        <!--          &lt;!&ndash;          <span class="common-status status-pending-order">待支付</span>&ndash;&gt;-->
        <!--          &lt;!&ndash;          <span class="common-status status-in-progress">运输中</span>&ndash;&gt;-->
        <!--        </template>-->
        <!--        <template v-slot:operation="{ row }">-->
        <!--          <span class="operate-btn" @click="openDetail(row)">详情</span>-->
        <!--        </template>-->
      </custom-table>
    </div>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import CustomCityCascader from "@/components/CustomCityCascader.vue";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    CustomCityCascader,
    OperateBox,
    CustomTable,
    CustomDateRange,
  },
  data() {
    return {
      getTableMethod: getPage,
      searchForm: {
        createTime: "",
        companyId: "",
      },
      haveCompany: true,
      isImmediatelyGetData: false,
      tableColumn: [
        {
          label: "预警时间",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "所属机构",
          prop: "orderSource",
          align: "left",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "司机联系方式",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "责任调度",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "车队长",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "入驻日期时间",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "累计收入",
          prop: "price",
          align: "left",
          show: true,
        },
        {
          label: "预警命中条件",
          prop: "createTime",
          align: "left",
          show: true,
        },
      ],
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/youxiaohuozhu.png"),
      statisticsImage3: require("@/assets/imgs/xiadanbishu.png"),
      statisticsImage4: require("@/assets/imgs/dingdanwancheng.png"),
      statisticsImage5: require("@/assets/imgs/leijijine.png"),
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleChangeTab(val) {
      this.selectTab = val;
    },
    openDetail(row) {
      this.$refs.detail.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .custom-tip {
    font-size: 0.16rem;
    padding: 0.16rem 0.2rem;
    background: rgba(18, 105, 255, 0.05);
    box-sizing: border-box;
    margin: 0 0.16rem;
    border-radius: 0.03rem;
    border: 0.01rem dashed #1269ff;
    display: flex;
    align-items: center;
    .tip-img {
      width: 0.44rem;
      height: 0.44rem;
      flex-shrink: 0;
      margin-right: 0.2rem;
    }
    .tip-title {
      display: flex;
      align-items: center;
      padding-bottom: 0.06rem;
      i {
        color: #cf9236;
        margin-right: 0.03rem;
      }
      span {
        color: #000000;
        font-size: 0.14rem;
      }
    }
    .tip-list {
      line-height: 0.26rem;
      box-sizing: border-box;
      font-size: 0.12rem;
      color: #434343;
    }
  }
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
  .statistics-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.16rem;
    margin: 0 -0.1rem;
    .statistics-list {
      width: 33.33%;
      height: 1.2rem;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
      .statistics-image {
        width: 0.8rem;
        height: 0.61rem;
      }
      .statistics-num {
        .num {
          font-size: 0.24rem;
          color: #000000;
          font-weight: bold;
          text-align: center;
        }

        .txt {
          font-size: 0.14rem;
          color: #434343;
          padding-top: 0.1rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
